import React, { useEffect, useState } from "react";
import "./Hero.css";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { IoIosAddCircleOutline } from "react-icons/io";
import { CiCircleCheck } from "react-icons/ci";
import { RiMovie2Line } from "react-icons/ri";
import { IoMdShare } from "react-icons/io";
import useDetailsHook from "../../hooks/DetailsHook";
import HttpApis from "../../services/HttpApis";
import { Modal, message } from "antd";
import { IoCopy } from "react-icons/io5";
import { BASE_BACKEND_URL } from "../../api/config";
import { btnColor } from "../../theme/color";
import { useWatchlist } from "../../hooks/useWatchlist";
import { useMyList } from "../../hooks/useMyList";
import { useConfig } from "../../ConfigContext";

import {
  FacebookShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  FacebookIcon,
  LinkedinIcon,
  WhatsappIcon,
} from "react-share";

const Hero = (props) => {
  const {
    title,
    description,
    info,
    posterUrl,
    data,
    type,
    handleDetails,
    details,
    handlePlayRoute,
    slug,
    addFavData,
    year,
    genre,
    rating,
    access,
  } = props;

  const loginUser = useSelector(
    (state) => state?.authReducer?.user?.data?.user
  );

  const navigate = useNavigate();
  const urlToShare = `${BASE_BACKEND_URL}`;
  const { formatTime } = useDetailsHook();
  const params = useParams();
  const authtoken = useSelector(
    (state) => state?.authReducer?.user?.data?.token
  );
  const config = useConfig();
  const enableLogin = config?.enable_login ?? true; // Default to true if not set

  // ✅ Use the watchlist hook for favorites (heart icon)
  const { isInWatchList, handleAdd: addToWatchlist, handleRemove: removeFromWatchlist } = useWatchlist(authtoken, slug);

  // ✅ Use the My List hook (add/checkmark icon)
  const { isInMyList, handleAdd: addToMyList, handleRemove: removeFromMyList } = useMyList(authtoken, slug);

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  const showLoading = () => {
    setOpen(true);
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  const handleLogin = () => {
    navigate("/login");
  };

  const handleCopy = () => {
    const link = `${BASE_BACKEND_URL}`;

    const tempInput = document.createElement("input");
    tempInput.value = link;
    document.body.appendChild(tempInput);

    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);
    message.success("Link copied to clipboard!");
  };

  return (
    <div className="hero-banner">
      <div className="hero-content">
        {/* Year | Genre | Rating */}
        <p className="hero-meta">
          {year && <span>{year}</span>}
          {genre && <span> | {genre}</span>}
          {rating && <span> | {rating}</span>}
          {access && <span> | {access}</span>}
        </p>
        <h1 className="hero-title">{title}</h1>
        {info && info > 0 && <p className="hero-info">{formatTime(info)}</p>}
        <p className="hero-description">{description}</p>

        {details && loginUser ? (
          <div className="playButtonBox">
            <button
              className="hero-button"
              style={{ backgroundColor: btnColor }}
              onClick={() =>
                handlePlayRoute(
                  params.id,
                  params.type,
                  params.monitization_type
                )
              }
            >
              Play
            </button>
            <div className="trailerBox">
              <RiMovie2Line
                className="addIcon"
                onClick={() => handlePlayRoute(params.id, params.type)}
              />

              {/* ✅ My List Button (uses isInMyList from hook) */}
              {isInMyList ? (
                <div onClick={removeFromMyList}>
                  <CiCircleCheck className="subtractIcon" />
                </div>
              ) : (
                <div onClick={addToMyList}>
                  <IoIosAddCircleOutline className="addIcon" />
                </div>
              )}

              <div>
                <IoMdShare className="subtractIcon" onClick={showLoading} />
              </div>
            </div>
          </div>
        ) : !enableLogin || loginUser ? (
          // If enable_login is false or user is logged in, show Details button
          <button
            className="hero-button"
            style={{ backgroundColor: btnColor }}
            onClick={() => handleDetails(data, type)}
          >
            Details
          </button>
        ) : (
          <button
            className="hero-button"
            style={{ backgroundColor: btnColor }}
            onClick={() => handleLogin(data)}
          >
            Login
          </button>
        )}
      </div>

      <div
        className="hero-background"
        style={{
          backgroundImage: `
      linear-gradient(to right, rgb(0, 0, 0,1) 15%, rgba(0, 0, 0, 0.9) 35%, rgba(0, 0, 0, 0) 100%),
      url(${posterUrl})
    `,
        }}
      ></div>

      <Modal
        footer={null}
        loading={null}
        open={open}
        onCancel={() => setOpen(false)}
        closeIcon={null}
      >
        <FacebookShareButton url={urlToShare}>
          <FacebookIcon className="socialIcon" round />
        </FacebookShareButton>

        <LinkedinShareButton url={urlToShare}>
          <LinkedinIcon className="socialIcon" round />
        </LinkedinShareButton>

        <WhatsappShareButton url={urlToShare}>
          <WhatsappIcon className="socialIcon" round />
        </WhatsappShareButton>

        <a href="javascript:void(0);" onClick={handleCopy}>
          <IoCopy className="socialIcon" />
        </a>
      </Modal>
    </div>
  );
};

export default Hero;